import React from "react";
import SignIn from "../components/SignIn/SignIn";

export default function SignInPage() {
  return (
    <div className="h-screen">
      <SignIn />
    </div>
  );
}
